if (!customElements.get('everwest-branding-studio')) {
  class EverwestBrandingStudio extends HTMLElement {
    connectedCallback() {
      this.iframe = this.querySelector('.everwest-branding-studio__frame');
      this.status = this.querySelector('[data-branding-status]');
      this.designInput = this.querySelector('[data-branding-design-input]');
      this.modelInput = this.querySelector('[data-branding-model-input]');
      this.handleMessage = this.handleMessage.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);

      try {
        this.studioOrigin = new URL(this.iframe.src).origin;
      } catch (_error) {
        this.showError('The Branding Studio URL is invalid. This item can still be ordered plain.');
        return;
      }

      window.addEventListener('message', this.handleMessage);
      this.getProductForm()?.addEventListener('submit', this.handleFormSubmit, true);
    }

    disconnectedCallback() {
      window.removeEventListener('message', this.handleMessage);
      this.getProductForm()?.removeEventListener('submit', this.handleFormSubmit, true);
    }

    getProductForm() {
      const configuredFormId = this.dataset.productFormId;
      if (configuredFormId) {
        const configuredForm = document.getElementById(configuredFormId);
        if (configuredForm) {
          return configuredForm;
        }
      }

      return document.querySelector('form[id^="product-form-main-"][action*="/cart/add"]');
    }

    handleFormSubmit() {
      this.syncFormAssociation();
    }

    syncFormAssociation() {
      const productForm = this.getProductForm();
      if (!productForm) {
        return;
      }

      this.designInput.setAttribute('form', productForm.id);
      this.modelInput.setAttribute('form', productForm.id);
    }

    handleMessage(event) {
      if (event.source !== this.iframe.contentWindow || event.origin !== this.studioOrigin) {
        return;
      }

      const message = event.data;
      if (!message || typeof message.type !== 'string') {
        return;
      }

      if (message.type === 'everwest:ready') {
        this.classList.add('is-ready');
        this.syncFormAssociation();
        return;
      }

      if (message.type === 'everwest:resize') {
        const requestedHeight = Number(message.height);
        if (Number.isFinite(requestedHeight)) {
          this.iframe.style.height = `${Math.min(Math.max(requestedHeight + 4, 900), 3000)}px`;
        }
        return;
      }

      if (message.type === 'everwest:design-change') {
        this.updateDesign(message);
      }
    }

    updateDesign(message) {
      const reviewUrl = typeof message.reviewUrl === 'string' ? message.reviewUrl : '';
      const isCustomized = message.isCustomized === true && Boolean(reviewUrl);
      if (!isCustomized) {
        this.designInput.value = '';
        this.designInput.disabled = true;
        this.modelInput.disabled = true;
        this.status.textContent = 'Branding is optional. Leave the studio blank to order this item plain.';
        this.status.classList.remove('is-saved', 'is-error');
        return;
      }

      if (typeof message.modelName !== 'string' || message.modelName !== this.dataset.modelName) {
        this.showError('The saved design does not match this product. This item can still be ordered plain.');
        return;
      }

      if (reviewUrl.length > 12000) {
        this.showError('This design is too complex to save. Please remove a few brands before adding it to the cart.');
        return;
      }

      this.designInput.value = reviewUrl;
      this.designInput.disabled = false;
      this.modelInput.disabled = false;
      this.syncFormAssociation();
      this.status.textContent = '✓ Branding design saved with this item';
      this.status.classList.add('is-saved');
      this.status.classList.remove('is-error');
    }

    showError(message) {
      this.designInput.value = '';
      this.designInput.disabled = true;
      this.modelInput.disabled = true;
      this.status.textContent = message;
      this.status.classList.remove('is-saved');
      this.status.classList.add('is-error');
    }
  }

  customElements.define('everwest-branding-studio', EverwestBrandingStudio);
}
